<template>
	<div class="content">
		<div class="title-c">
			Reports
		</div>

		<div v-show="tradingType == 'jgx'" class="tab-content tab-space">

			<!-- Order -->
			<div v-show="tabActive == 'orders'" :class="`${tabActive == 'orders' && 'active'}`" id="nav1-link1"
				:aria-expanded="`${tabActive == 'orders' ? 'true' : 'false'}`">

				<Orders></Orders>
			</div>

			<!-- Transactions -->
			<div v-show="tabActive == 'transactions'" :class="`${tabActive == 'transactions' && 'active'}`" id="nav1-link2"
				:aria-expanded="`${tabActive == 'transactions' ? 'true' : 'false'}`">
				<Transactions ref="transactionsRef"></Transactions>
			</div>

			<!-- Holdings -->
			<div v-show="tabActive == 'holdings'" :class="`${tabActive == 'holdings' && 'active'}`" id="nav1-link3"
				:aria-expanded="`${tabActive == 'holdings' ? 'true' : 'false'}`">
				<Holdings @afterTradeSuccess="refetchTransactions"></Holdings>
			</div>

			<!-- CLIENTS -->
			<div v-show="tabActive == 'clients' && (accountLevel == 'ib' || accountLevel == 'fm')"
				:class="`${tabActive == 'clients' && 'active'}`" id="nav1-link-clients"
				:aria-expanded="`${tabActive == 'clients' ? 'true' : 'false'}`">
				<Clients></Clients>
			</div>

			<!-- Statements -->
			<div v-show="tabActive == 'statements'" :class="`${tabActive == 'statements' && 'active'}`" id="nav1-link4"
				:aria-expanded="`${tabActive == 'statements' ? 'true' : 'false'}`">
				<div class="row justify-content-center">
					<div class="px-3 mb-3" style="width: 380px !important;">
						<!-- <h5 class="text-left">SELECT A DATE RANGE</h5> -->

						<div class="form-group">
							<label for="startDateStatements">Start Date</label>
							<input type="date" class="form-control" id="startDateStatements">
						</div>

						<div class="form-group">
							<label for="endDateStatements">End Date</label>
							<input type="date" class="form-control" id="endDateStatements">
						</div>


						<!-- <h4>REQUEST NEW CREDIT LIMIT</h4>
						<div class="input-group input-group-lg mb-3">
							<div class="input-group-prepend">
								<span class="input-group-text" id="inputGroup-sizing-sm">AUD $</span>
							</div>
							<input type="number" class="form-control" aria-label="Small" aria-describedby="inputGroup-sizing-sm">
							
								<button class="btn btn-sm" type="button">-</button>
								<button class="btn btn-sm" type="button">+</button>
					
						</div>
						<div class="form-group">
							<textarea class="form-control" placeholder="Optional description" rows="5" style="max-height: 200px;"></textarea>
						</div> -->
					</div>
					<div class="w-full"></div>
					<div class="px-3 text-center" style="width: 380px !important;">
						<div title="Coming Soon text-center">
							<button type="button" class="btn btn-success" disabled>RUN STATEMENT REPORT</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Account balance history -->
			<div v-show="tabActive == 'accountBalanceHistory'" :class="`${tabActive == 'accountBalanceHistory' && 'active'}`"
				id="nav1-link5" :aria-expanded="`${tabActive == 'accountBalanceHistory' ? 'true' : 'false'}`">
				<AccountBalance></AccountBalance>
			</div>

			<!-- Cash In Cash Out -->
			<!-- <div v-if="accountLevel == 'ib'" class="tab-pane" id="nav1-link6" aria-expanded="false">
				<div class="row text-right mb-2">
					<div v-if="accountLevel == 'ib' || accountLevel == 'fm' || accountLevel == 'ccp'" class="col-auto mb-2 text-left">
						<FilterClient class="d-inline-block"
							filterId="accountBalanceHistory"
							@changeFilterClient="changeFilterClientAccountBalanceHistory"
							:clients_prop="listClients"
						>
						</FilterClient>
					</div>
				</div>

				<div class="row">
					<div class="col">
						<Pagination
							:maxPage_prop =	"accountBalanceHistoriesShowed.length"
							@changePage = "accountBalanceHistoriesPageIndex = $event"
							:status_prop = "accountBalanceHistoriesStatus"
						>
						</Pagination>
					</div>
					<div class="col-12 table-responsive p-0">
						<table class="table table--report text-nowrap">
							<thead>
								<tr>
									<th scope="col">DATE</th>
									<th scope="col">TRANSACTION ID</th>
									<th scope="col">DEBIT</th>
									<th scope="col">CREDIT</th>
								</tr>
							</thead>
							<tbody>
								<template v-if="lastTenTransactions.length > 0">
									<tr v-for="(item, index) in lastTenTransactions" :key="index">
										<td>{{ item.date }}</td>
										<td>{{ item.transactionId }}</td>
										<td>{{ item.debit }}</td>
										<td>{{ item.credit }}</td>
									</tr>
								</template>
<template v-else>
									<tr>
										<td></td>
										<td></td>
										<td></td>
										<td></td>
									</tr>
								</template>
</tbody>
</table>

</div>
</div>
</div> -->
		</div>
	</div>
</template>

<script>
/*eslint-env jquery*/
import Decimal from 'decimal.js'

import Orders from '@/components/reports/orders/Orders.vue'
import Transactions from '@/components/reports/transactions/Transactions.vue'
import Holdings from '@/components/reports/holdings/Holdings.vue'
import Clients from '@/components/reports/clients/Clients.vue'
import AccountBalance from '../components/reports/account-balance/AccountBalance.vue'

import ReportsNav from '@/components/reports/ReportsNav.vue'
import Pagination from '@/components/Pagination.vue'
import Pagination2 from '@/components/Pagination2.vue'
import Loader from '@/components/Loader.vue'
import FilterContract from '@/components/FilterContract.vue'
// import ExportAsButton from '@/components/ExportAsButton.vue'
import FilterDateAndType from '@/components/FilterDateAndType.vue'
import FilterClient from '@/components/FilterClient.vue'
import FilterOrderType from '@/components/FilterOrderType.vue'


export default {
	name: 'Reports',

	components: {
		Orders,
		Transactions,
		Holdings,
		Clients,
		AccountBalance,

		ReportsNav,
		Pagination,
		Pagination2,
		Loader,
		FilterContract,
		// ExportAsButton,
		FilterDateAndType,
		FilterClient,
		FilterOrderType
	},

	data() {
		return {
			Decimal: Decimal,
			accountLevel: this.$store.getters.getAccountLevel,
			contracts: '',
			// products: '',
			hubs: '',

			transactions: [],
			transactionsStatus: 'loading',

			filterType: 'jgx',

			listClients: [],

			filterContractTransaction: [],
			selectedClientTransaction: 'all',
			filterDateAndTypeTransaction: {
				type: 'day',
				startDate: '',
				endDate: ''
			},

			totalTransactions: 1,
			cancelTokenApiGetTransactions: '',
			cancelTokenApiGetHinTransactions: '',
			orderTypeTransactions: 'all',

			clients: [],
			totalClients: 1,
			apiStatusGetClients: 'idle',

			clientsBalance: [],

			selectedClientAccountBalanceHistory: 'all',

			accountBalanceHistories: [],
			accountBalanceHistoriesStatus: 'idle',

			totalAccountBalanceHistory: 1,
			cancelTokenApiGetAccountBalanceHistory: '',
			cancelTokenApiGetHinAccountBalanceHistory: '',

			bankTransactions: [],
			totalBankTransactions: 1,
			apiSkipGetBankTransactions: '0',
			apiStatusGetBankTransactions: 'loading',
			cancelTokenApiBankTransactions: '',

			invoiceLoading: [],

			lastTenTransactions: [],

			setIntervalFetchGoldInventory: null,
		}
	},

	computed: {
		tabActive() {
			return this.$store.state.reportToShow
		},

		currency() {
			return this.$store.state.currency
		},
		hin() {
			return this.$store.getters.getHin
		},
		tradingType() {
			return this.$store.state.tradingType
		},

		hubsTemp() {
			return this.$store.state.hubs
		},

		contractsTemp() {
			return this.$store.state.contracts
		},

		products() {
			return this.$store.getters.PRODUCTS
		},

		currencySymbol() {
			if (this.currency == 'idr') {
				return 'Rp '
			} else {
				return '$'
			}
		},

		streamingRate() {
			return this.$store.getters.getStreamingRate
		},

		streamingRateBuy() {
			if (this.currency == 'idr') {
				return this.streamingRate.streamBuy
			} else {
				return 1
			}
		},

		streamingRateSell() {
			if (this.currency == 'idr') {
				return this.streamingRate.streamSell
			} else {
				return 1
			}
		},

		availableTradeBalance() {
			if (!this.$store.state.balances) {
				return -1
			}

			if (this.currency == 'idr') {
				return this.$store.state.balances.available_trade_bal
			} else {
				return this.$store.state.balances.available_trade_bal_usd
			}
		},
		accountBalance() {
			if (!this.$store.state.balances) {
				return -1
			}

			if (this.currency == 'idr') {
				return this.$store.state.balances.rdk_balance
			} else {
				return this.$store.state.balances.account_bal
			}
		},

		// watcherHubsContractsProducts() {
		// 	return `${this.hubsTemp}${this.contractsTemp}${this.products}`
		// }
	},

	created() {
		// set goldBalance in store
		this.$store.dispatch('goldBalanceNew/fetchGoldBalance', {
			user_id: this.$store.state.userId,
		})
	},

	destroyed() {
		if (this.setIntervalFetchGoldInventory) {
			clearInterval(this.setIntervalFetchGoldInventory)
		}
	},

	methods: {
		refetchTransactions() {

			console.log('CLOSE TRADE TICKET', this.$refs.transactionsRef)
			this.$refs.transactionsRef.setTransactions()
		}
	}
}
</script>

<style scoped>
.c-row-table:hover {
	background-color: rgb(0, 0, 0, 0.3);
	cursor: pointer;
}

.title-c {
	font-size: 1.625rem;
	color: white;
}
</style>
